var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 7.5,
    stroke: "#E5EAF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6929 10.3054C15.597 10.2066 15.4662 10.1513 15.3266 10.1484C15.1842 10.1484 15.0534 10.2008 14.9516 10.3025L10.0504 15.2065C9.84695 15.41 9.84695 15.7443 10.0504 15.9478C10.1493 16.0466 10.2801 16.0989 10.4196 16.0989C10.5592 16.0989 10.6929 16.0437 10.7888 15.9478L15.69 11.0466C15.7888 10.9477 15.8441 10.8169 15.8441 10.6745C15.8441 10.532 15.7888 10.4012 15.69 10.3053L15.6929 10.3054Z",
    fill: "#7389C3",
    stroke: "#7389C3",
    strokeWidth: 0.37337
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02126 19.5C7.04451 19.5 7.06196 19.5 7.09103 19.4942L10.8875 18.9826C11.0008 18.9709 11.1084 18.9186 11.1869 18.8372L19.1433 10.8808C19.1433 10.8808 19.152 10.875 19.1549 10.8692L19.8701 10.154C20.277 9.74707 20.5009 9.20346 20.5009 8.62789C20.5009 8.05232 20.277 7.51162 19.8701 7.10755L18.8933 6.13081C18.4864 5.72383 17.9456 5.5 17.3701 5.5C16.7945 5.5 16.2567 5.72383 15.8468 6.13081L15.3468 6.6308L15.3352 6.63952C15.3352 6.63952 15.309 6.65987 15.2974 6.6715L7.16369 14.811C7.0823 14.8924 7.02997 14.997 7.01543 15.1104L6.50381 18.9069C6.48346 19.0697 6.53579 19.2295 6.65207 19.3458C6.74799 19.4417 6.88463 19.5 7.02126 19.5ZM16.2393 7.21225L16.5881 6.86632C16.7974 6.65702 17.0765 6.54074 17.373 6.54074C17.6695 6.54074 17.9486 6.65702 18.1579 6.86632L19.1346 7.84306C19.5648 8.27329 19.5648 8.97678 19.1346 9.40991L18.7858 9.75875L16.2393 7.21225ZM7.63167 18.3662L8.02702 15.4245L15.4979 7.95364L18.0415 10.4973L10.5734 17.9711L7.63167 18.3662Z",
    fill: "#7389C3",
    stroke: "#7389C3",
    strokeWidth: 0.37337
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.51e7755d96ebcd9846024ead11edc9fb.svg";
export { ForwardRef as ReactComponent };